/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';
// @ts-ignore
import type { MonthlyOrderMetrics } from './MonthlyOrderMetrics';
// @ts-ignore
import {
// @ts-ignore
    MonthlyOrderMetricsFromJSON,
// @ts-ignore
    MonthlyOrderMetricsFromJSONTyped,
// @ts-ignore
    MonthlyOrderMetricsToJSON,
} from './MonthlyOrderMetrics';

/**
 * 
 * @export
 * @interface MonthlyOrderMetricsResult
 */
export interface MonthlyOrderMetricsResult {
    /**
     * Raw metrics grouped by currency.
     * @type {Array<MonthlyOrderMetrics>}
     * @memberof MonthlyOrderMetricsResult
     */
    metrics: Array<MonthlyOrderMetrics>;
    /**
     * Metrics converted into a single currency.
     * @type {Array<MonthlyOrderMetrics>}
     * @memberof MonthlyOrderMetricsResult
     */
    summary: Array<MonthlyOrderMetrics>;
    /**
     * Total number of orders across all summary entries.
     * @type {number}
     * @memberof MonthlyOrderMetricsResult
     */
    totalCount: number;
    /**
     * 
     * @type {Amount}
     * @memberof MonthlyOrderMetricsResult
     */
    totalAmount: Amount;
    /**
     * 
     * @type {number}
     * @memberof MonthlyOrderMetricsResult
     */
    supplierCount: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyOrderMetricsResult
     */
    storeCount: number;
}

/**
 * Check if a given object implements the MonthlyOrderMetricsResult interface.
 */
// @ts-ignore
export function instanceOfMonthlyOrderMetricsResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "metrics" in value;
    isInstance = isInstance && "summary" in value;
    isInstance = isInstance && "totalCount" in value;
    isInstance = isInstance && "totalAmount" in value;
    isInstance = isInstance && "supplierCount" in value;
    isInstance = isInstance && "storeCount" in value;

    return isInstance;
}

// @ts-ignore
export function MonthlyOrderMetricsResultFromJSON(json: any): MonthlyOrderMetricsResult {
    return MonthlyOrderMetricsResultFromJSONTyped(json, false);
}

// @ts-ignore
export function MonthlyOrderMetricsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthlyOrderMetricsResult {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metrics': ((json['metrics'] as Array<any>).map(MonthlyOrderMetricsFromJSON)),
        'summary': ((json['summary'] as Array<any>).map(MonthlyOrderMetricsFromJSON)),
        'totalCount': json['total_count'],
        'totalAmount': AmountFromJSON(json['total_amount']),
        'supplierCount': json['supplier_count'],
        'storeCount': json['store_count'],
    };
}

// @ts-ignore
export function MonthlyOrderMetricsResultToJSON(value?: MonthlyOrderMetricsResult | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metrics': ((value.metrics as Array<any>).map(MonthlyOrderMetricsToJSON)),
        'summary': ((value.summary as Array<any>).map(MonthlyOrderMetricsToJSON)),
        'total_count': value.totalCount,
        'total_amount': AmountToJSON(value.totalAmount),
        'supplier_count': value.supplierCount,
        'store_count': value.storeCount,
    };
}

